import React from "react";
import "./GPTeam.css";

const teamMembers = [
  { name: "श्री. अभिषेक अशोक देवगडे", designation: "ग्रामपंचायत सदस्य सायकी", phone: "+91-", imageUrl: "/images/abhi.jpeg" },
  { name: "श्री चिरकुट गोमा नेवारे", designation: "ग्रामपंचायत सदस्य सायकी", phone: "+91-", imageUrl: "/images/chirkut.jpeg" },
  { name: "श्री.चंद्रभान तेलरांधे", designation: "ग्रामपंचायत सदस्य सायकी", phone: "+91-", imageUrl: "/images/men.png" },
  { name: "सौ. कविता राऊत", designation: "ग्रामपंचायत सदस्य सायकी", phone: "+91-", imageUrl: "/images/kavita.jpeg" },
  { name: "श्रीमती. इंदू सुरेश सहारे", designation: "ग्रामपंचायत सदस्य सायकी", phone: "+91-", imageUrl: "/images/indu.jpeg" },
  { name: "सौ.शशिकला उमेश गणवीर", designation: "ग्रामपंचायत सदस्य सायकी", phone: "+91-", imageUrl: "/images/ganvir.jpeg" },
 
];

// === नवीन कर्मचारी Data ===
const employees = [
    { name: " सुनील भोसकर", designation: "संगणक परिचालक ", phone: "+91-9284330156", imageUrl: "/images/operator.jpeg" },

 { name: "सुनीता धोपटे", designation: " अंगणवाडी सेविका", phone: "+91- 9373960752", imageUrl: "/images/sunita.jpeg" },
 
  { name: "आनंदराव व्यापारी", designation: " ग्राम पंचायत शिपाई", phone: "+91- 8308310907", imageUrl: "/images/sipahi.jpeg" },
  { name: "विलास रोहनकर", designation: "ग्राम पंचायत  पाणी पुरवठा सहाय्यक दाभा", phone: "+91-9370923726", imageUrl: "/images/waterpamp.jpeg" },
  
    


];

const GPTeam = () => {
  return (
    <div className="gp-container">

      {/* HEADER */}
      <div className="gp-header">
        <img src="/images/sj1.jpg" alt="Emblem" className="gp-logo" />
        <h1 className="gp-title">ग्रामपंचायत कार्यकारी समिती</h1>
        <p className="gp-subtitle">The Governing Body — Committed to Community Service</p>
      </div>

      {/* TEAM MEMBERS GRID */}
      <div className="gp-grid">
        {teamMembers.map((member, index) => (
          <div key={index} className="gp-card">
            <img src={member.imageUrl} alt={member.name} className="gp-photo" />
            <h2 className="gp-name">{member.name}</h2>
            <p className="gp-designation">{member.designation}</p>
            <p className="gp-phone">📞 {member.phone}</p>
          </div>
        ))}
      </div>

      {/* ---- कर्मचार्‍यांचा विभाग ---- */}
      <h1 className="gp-title" style={{ marginTop: "40px" }}>
        🌟 ग्रामपंचायत कर्मचारी 🌟
      </h1>

      <div className="gp-grid">
        {employees.map((emp, index) => (
          <div key={index} className="gp-card">
            <img src={emp.imageUrl} alt={emp.name} className="gp-photo" />
            <h2 className="gp-name">{emp.name}</h2>
            <p className="gp-designation">{emp.designation}</p>
            <p className="gp-phone">📞 {emp.phone}</p>
          </div>
        ))}
      </div>

      {/* FOOTER */}
      <div className="gp-footer">© 2025 Gram Panchayat — All Rights Reserved.</div>
    </div>
  );
};

export default GPTeam;
